import type { VariantProps } from "class-variance-authority";
import { cva, cx } from "class-variance-authority";
import { inputVariants } from "@/components/ui/input/variants.input";

const selectTriggerBase = cva(
  "ring-offset-background placeholder:text-muted-foreground text-foreground dark:open:bg-brand-9/10 dark:focus:bg-brand-9/10 hover:border-accent-11 focus:border-accent-11 open:border-accent-11 focus:shadow-0 focus-visible:border-accent-11 focus-visible:outline-hidden focus:glow-xs-accent-11/10 custom-transition flex w-full items-center justify-between rounded border px-3 pl-3.5 py-1 text-sm focus:outline-hidden focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50"
);

export const selectTriggerVariants = (props: VariantProps<typeof inputVariants>) =>
  cx(inputVariants(props), selectTriggerBase());

export type SelectTriggerVariants = VariantProps<typeof selectTriggerVariants>;

export const selectContentVariants = cva(
  "bg-popover text-popover-foreground open:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 open:fade-in-0 data-[state=closed]:zoom-out-95 open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative w-full min-w-32 overflow-hidden rounded-md border shadow-md z-200",
  {
    variants: {
      popper: {
        true: "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      },
    },
    defaultVariants: {
      popper: true,
    },
  }
);

export const selectItemVariants = cva(
  "focus:bg-muted/50 focus:text-accent-foreground relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-hidden data-disabled:pointer-events-none data-disabled:opacity-50"
);
